<template>
  <div>
    <div class="add-textarea-box row items-center" v-if="!open" @click="open = true">
      <q-icon name="add"/>
      <span>{{ $t('create_template') }}</span>
    </div>
    <div v-else>
    <q-field
      :error="errors.has('name')"
      :error-label="errors.first('name')"
    >
      <q-input
        :placeholder="$t('name')"
        v-validate.disable="'max:100'"
        v-model="formData.name"
        name="name"
      />
    </q-field>
    <q-field
      :error="errors.has('text')"
      :error-label="errors.first('text')"
    >
      <q-editor
        ref="editor"
        v-model="formData.content"
        :toolbar="toolbar"
        toolbar-bg="white"
        toolbar-text-color="grey-7"
        class="q-mt-lg round-borders"
        style="overflow: hidden"
        v-validate.disable="'required|min:1|max:100000'"
        :placeholder="$t('text')"
        toolbar-flat
      />
    </q-field>
    <div class="row justify-end q-mt-md">
      <q-btn flat :label="$t('abort')" @click="reset"/>
      <q-btn flat :label="$t('save')" @click="handleSave"/>
    </div>
    </div>
  </div>
</template>

<script>
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapActions } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    props: {
      template: {
        type: Object,
        required: false
      },

      type: {
        type: String,
        required: true
      },

      model: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        open: false,
        formData: {
          name: '',
          content: ''
        }
      }
    },
    methods: {
      ...mapActions([
        'createInvoiceTextTemplate',
        'createQuoteTextTemplate',
        'updateInvoiceTextTemplate',
        'updateQuoteTextTemplate'
      ]),

      handleSave () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) throw new Error('validation')

            const template = {
              type: this.type,
              name: this.formData.name,
              content: this.formData.content
                ? this.formData.content.replaceAll('</div>', '').replaceAll('<div>', '<br />') // Fix for QEditor not supporting paragraphs
                : this.formData.content
            }

            return this.template !== null
              ? this.update(template)
              : this.create(template)
          })
          .then(() => {
            this.$q.notify({ message: this.$t('text_template_saved'), type: 'positive' })
            this.reset()
          })
          .catch(error => {
            if (error.message !== 'validation') createErrorFromResponse(error)
          })
      },

      reset () {
        this.open = false
        this.formData.name = null
        this.formData.content = null
      },

      create (template) {
        return this.isInvoice
          ? this.createInvoiceTextTemplate(template)
          : this.createQuoteTextTemplate(template)
      },

      update (template) {
        return this.isInvoice
          ? this.updateInvoiceTextTemplate({ template, id: this.template.id })
          : this.updateQuoteTextTemplate({ template, id: this.template.id })
      }
    },
    computed: {
      isInvoice () {
        return this.model === 'invoice'
      },
      toolbar () {
        return [
          ['bold', 'italic'],
          ['unordered', 'ordered'],
          ['removeFormat']
        ]
      }
    },
    watch: {
      template (value) {
        this.open = true
        this.formData.name = value.name
        this.formData.content = value.content
      }
    }
  }
</script>
